
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quests",
      function () {
        return require("private-next-pages/quests/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quests"])
      });
    }
  